<h2 class="terra-headline-3 section-heading">Core Values</h2>
<p class="terra-body section-desc">
  Select +, +/-, or - for each Core Value regarding
  <strong>{{ discussion.managee | userName }}</strong>
  .
</p>

<ion-list [formGroup]="form">
  @for (ctrl of managerRatingsCtrls; track ctrl; let i = $index) {
    <h3 class="terra-title-small section-question-heading">
      {{ discussion.managerDiscussionForm?.coreValueRatings?.[i]?.coreValue?.name }}
    </h3>
    <p class="terra-body section-question-desc">
      {{ discussion.managerDiscussionForm?.coreValueRatings?.[i]?.coreValue?.description }}
    </p>

    @if (isMeeting || isManager) {
      @if (isMeeting) {
        <p>{{ discussion.manager | userName }}</p>
      }
      <ion-segment [formControl]="ctrl">
        <ion-segment-button [value]="ValueRating.POSITIVE" [disabled]="ctrl.disabled" class="positive">
          <span>+</span>
        </ion-segment-button>
        <ion-segment-button [value]="ValueRating.SOMETIMES" [disabled]="ctrl.disabled" class="neutral">
          <span>+/-</span>
        </ion-segment-button>
        <ion-segment-button [value]="ValueRating.NEGATIVE" [disabled]="ctrl.disabled" class="negative">
          <span>-</span>
        </ion-segment-button>
      </ion-segment>
    }

    @if (isMeeting || isManagee) {
      @if (isMeeting) {
        <p>{{ discussion.managee | userName }}</p>
      }
      <ion-segment [formControl]="manageeRatingsCtrls[i]">
        <ion-segment-button
          [value]="ValueRating.POSITIVE"
          [disabled]="manageeRatingsCtrls[i].disabled"
          class="positive">
          <span>+</span>
        </ion-segment-button>
        <ion-segment-button
          [value]="ValueRating.SOMETIMES"
          [disabled]="manageeRatingsCtrls[i].disabled"
          class="neutral">
          <span>+/-</span>
        </ion-segment-button>
        <ion-segment-button
          [value]="ValueRating.NEGATIVE"
          [disabled]="manageeRatingsCtrls[i].disabled"
          class="negative">
          <span>-</span>
        </ion-segment-button>
      </ion-segment>
    }
  }
</ion-list>

@if (isMeeting || isManager) {
  <nty-textarea
    [formControl]="form.controls.manager.controls.notes"
    [label]="managerCommentLabel"
    placeholder="Enter comments" />
}

@if (isMeeting || isManagee) {
  <nty-textarea
    [formControl]="form.controls.managee.controls.notes"
    [label]="manageeCommentLabel"
    placeholder="Enter comments" />
}
